<script lang="ts" setup>
  withDefaults(
    defineProps<{
      textColor?: string;
      loadingText?: string;
    }>(),
    {
      textColor: '#000',
      loadingText: 'Loading...',
    },
  );
</script>

<template>
  <div class="flex flex-col gap-1.5 items-center justify-center">
    <svg class="w-[50px] h-[50px] animate-spin" viewBox="0 0 50 50">
      <circle
        class="stroke-[#93bfec] [stroke-linecap:round] animate-dash"
        cx="25"
        cy="25"
        fill="none"
        r="20"
        stroke-width="5"
      />
    </svg>
    <slot>
      <span v-if="loadingText?.length" :style="{ color: textColor }">
        {{ loadingText }}
      </span>
    </slot>
  </div>
</template>
